import { render } from "./DynamicActions.vue?vue&type=template&id=3a24dd81&ts=true"
import script from "./DynamicActions.vue?vue&type=script&lang=ts"
export * from "./DynamicActions.vue?vue&type=script&lang=ts"

import "./DynamicActions.vue?vue&type=style&index=0&id=3a24dd81&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__